<zxing-scanner
  #scanner
  (camerasFound)="onCamerasFound($event)"
  (camerasNotFound)="onCamerasNotFound($event)"
  (torchCompatible)="onTorchCompatible($event)"
  (scanSuccess)="scanSuccessHandler($event)"
  [torch]="torchEnabled"
  [class]="camerasFound ? 'scanner' : 'd-none'"
  [formats]="allowedFormats"
  [timeBetweenScans]="50"
></zxing-scanner>

<button *ngIf="torchAvailable" (click)="toggleTorch()">
  <mat-icon>{{torchEnabled ? 'flash_off' : 'flash_on' }}</mat-icon>
</button>

<div class="cameras-not-found-text" *ngIf="!camerasFound">Camera is not found!</div>
